var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_ViewContract"),
        width: _vm.isZh ? "750px" : "850px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          attrs: {
            inline: true,
            "label-width": _vm.isZh ? "80px" : "130px",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Parter")))]
                      ),
                      _c("cargo-advance-select", {
                        staticStyle: { width: "230px" },
                        attrs: {
                          no: "cmpIdx",
                          disabled: true,
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          filterable: "",
                          "method-params": { active: true },
                          "default-value": _vm.tempCreditVO.cmpIdx || ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.tempCreditVO.cmpIdx = p.value || 0
                            _vm.tempCreditVO.branchId =
                              _vm.$store.getters.currentOfficeId
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_ContractNumber"))
                          )
                        ]
                      ),
                      _c("el-input", {
                        staticStyle: { width: "230px" },
                        attrs: { no: "contractNo", disabled: true },
                        model: {
                          value: _vm.tempCreditVO.contractNo,
                          callback: function($$v) {
                            _vm.$set(_vm.tempCreditVO, "contractNo", $$v)
                          },
                          expression: "tempCreditVO.contractNo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("div", {
            staticStyle: {
              "border-bottom": "2px solid #E3E3E3",
              "margin-bottom": "10px",
              "margin-top": "10px"
            }
          }),
          _c(
            "span",
            { staticStyle: { "line-height": "25px", "font-weight": "bold" } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CurrentCredit")))]
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.limit") } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "70px" },
                        attrs: {
                          no: "credit",
                          disabled: "",
                          min: 0,
                          precision: 0,
                          controls: false
                        },
                        model: {
                          value: _vm.tempCreditVO.credit,
                          callback: function($$v) {
                            _vm.$set(_vm.tempCreditVO, "credit", $$v)
                          },
                          expression: "tempCreditVO.credit"
                        }
                      }),
                      _c(
                        "el-select",
                        {
                          staticStyle: { "margin-left": "5px", width: "88px" },
                          attrs: { no: "currency", disabled: "" },
                          model: {
                            value: _vm.tempCreditVO.currency,
                            callback: function($$v) {
                              _vm.$set(_vm.tempCreditVO, "currency", $$v)
                            },
                            expression: "tempCreditVO.currency"
                          }
                        },
                        _vm._l(_vm.currencySet, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.code, value: item.code }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.accountPeriod") } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "74px" },
                        attrs: {
                          no: "dateLimited",
                          disabled: "",
                          min: 0,
                          precision: 0,
                          controls: false
                        },
                        model: {
                          value: _vm.tempCreditVO.creditDateLimited,
                          callback: function($$v) {
                            _vm.$set(_vm.tempCreditVO, "creditDateLimited", $$v)
                          },
                          expression: "tempCreditVO.creditDateLimited"
                        }
                      }),
                      _c(
                        "el-select",
                        {
                          staticStyle: { "margin-left": "5px", width: "70px" },
                          attrs: { no: "termUnit", disabled: "" },
                          model: {
                            value: _vm.tempCreditVO.termUnit,
                            callback: function($$v) {
                              _vm.$set(_vm.tempCreditVO, "termUnit", $$v)
                            },
                            expression: "tempCreditVO.termUnit"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: _vm.$t("Partners.day"), value: 0 }
                          }),
                          _c("el-option", {
                            attrs: { label: _vm.$t("Partners.week"), value: 1 }
                          }),
                          _c("el-option", {
                            attrs: { label: _vm.$t("Partners.month"), value: 2 }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("div", {
            staticStyle: {
              "border-bottom": "2px solid #E3E3E3",
              "margin-bottom": "10px",
              "margin-top": "10px"
            }
          }),
          _c(
            "span",
            { staticStyle: { "line-height": "25px", "font-weight": "bold" } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ContractTerms")))]
          ),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.dateType") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "163px" },
                          attrs: { no: "dateType", disabled: true },
                          model: {
                            value: _vm.tempCreditVO.contractDateType,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.tempCreditVO,
                                "contractDateType",
                                $$v
                              )
                            },
                            expression: "tempCreditVO.contractDateType"
                          }
                        },
                        _vm._l(_vm.dateTypeList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.$getLangColumn(item),
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.settlementMethod") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { no: "cbType", disabled: true },
                          model: {
                            value: _vm.cbType,
                            callback: function($$v) {
                              _vm.cbType = $$v
                            },
                            expression: "cbType"
                          }
                        },
                        _vm._l(_vm.cbTypeList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.label, value: item.value }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm.cbType === "n"
                    ? _c("el-input-number", {
                        staticStyle: { width: "70px" },
                        attrs: {
                          no: "tiDateSpecify",
                          disabled: true,
                          value: _vm.tiDateSpecify || undefined,
                          min: 0,
                          max: 31,
                          precision: 0,
                          controls: false
                        },
                        on: {
                          input: function(val) {
                            this$1.tiDateSpecify = val
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.limit") } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "70px" },
                        attrs: {
                          no: "contractCredit",
                          disabled: true,
                          min: 0,
                          precision: 0,
                          controls: false
                        },
                        model: {
                          value: _vm.tempCreditVO.contractCredit,
                          callback: function($$v) {
                            _vm.$set(_vm.tempCreditVO, "contractCredit", $$v)
                          },
                          expression: "tempCreditVO.contractCredit"
                        }
                      }),
                      _c(
                        "el-select",
                        {
                          staticStyle: { "margin-left": "5px", width: "88px" },
                          attrs: { no: "contractCurrency", disabled: true },
                          model: {
                            value: _vm.tempCreditVO.contractCurrency,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.tempCreditVO,
                                "contractCurrency",
                                $$v
                              )
                            },
                            expression: "tempCreditVO.contractCurrency"
                          }
                        },
                        _vm._l(_vm.currencySet, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.code, value: item.code }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.accountPeriod") } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "74px" },
                        attrs: {
                          no: "contractCreditDateLimited",
                          disabled: true,
                          min: 0,
                          precision: 0,
                          controls: false
                        },
                        model: {
                          value: _vm.tempCreditVO.contractCreditDateLimited,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.tempCreditVO,
                              "contractCreditDateLimited",
                              $$v
                            )
                          },
                          expression: "tempCreditVO.contractCreditDateLimited"
                        }
                      }),
                      _c(
                        "el-select",
                        {
                          staticStyle: { "margin-left": "5px", width: "70px" },
                          attrs: { no: "contractTermUnit", disabled: true },
                          model: {
                            value: _vm.tempCreditVO.contractTermUnit,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.tempCreditVO,
                                "contractTermUnit",
                                $$v
                              )
                            },
                            expression: "tempCreditVO.contractTermUnit"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: _vm.$t("Partners.day"), value: 0 }
                          }),
                          _c("el-option", {
                            attrs: { label: _vm.$t("Partners.week"), value: 1 }
                          }),
                          _c("el-option", {
                            attrs: { label: _vm.$t("Partners.month"), value: 2 }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.settlementType") } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { no: "settlementByBill", disabled: true },
                          model: {
                            value: _vm.settlementByBill,
                            callback: function($$v) {
                              _vm.settlementByBill = $$v
                            },
                            expression: "settlementByBill"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v(_vm._s(_vm.$t("Partners.settlementByBill")))
                          ]),
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("Partners.settlementNotByBill") +
                                  "（" +
                                  _vm.$t(
                                    "CargoMsg.Cargo_SettlementMethodGreaterThan0"
                                  ) +
                                  "）"
                              )
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          staticStyle: {
            width: "100%",
            height: "100%",
            "margin-bottom": "8px"
          },
          attrs: { type: "card" },
          model: {
            value: _vm.activeTabName,
            callback: function($$v) {
              _vm.activeTabName = $$v
            },
            expression: "activeTabName"
          }
        },
        [
          _c(
            "el-tab-pane",
            {
              staticStyle: { width: "100%", height: "100%" },
              attrs: {
                lazy: true,
                label: _vm.$t("CargoMsg.Cargo_TempCredit"),
                name: "otherDocuments"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row row-grid",
                  staticStyle: { "min-height": "300px" }
                },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: { height: "100%", "min-height": "220px" },
                    attrs: {
                      "column-defs": _vm.tempCreditInfo.columnDefs,
                      "grid-options": _vm.tempCreditInfo.gridOptions,
                      "row-data": _vm.tempCreditInfo.rowData,
                      "show-side-bar": false
                    }
                  })
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c("span", [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_TempCreditNotice")))]),
      _c(
        "template",
        { staticStyle: { height: "65px" }, slot: "footer" },
        [
          _c("approval-comments-and-btns", {
            attrs: {
              "process-info": _vm.processInfo,
              records: _vm.records,
              type: _vm.type
            },
            on: {
              close: function($event) {
                return _vm.$emit("close")
              },
              closeAndRefresh: function($event) {
                return _vm.$emit("closeAndRefresh")
              }
            }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }